import { AttachFileRounded, CloseRounded } from "@mui/icons-material";
import Button from "@mui/material/Button";
import isFunction from "lodash/isFunction";
import PropTypes from "prop-types";
import Flx from "../layout/Flx";

const FilesListRenderer = ({ files, onFileDelete, sx }) => {
  if (!files || !Array.isArray(files) || files.length === 0) {
    return null;
  }

  const handleOnFileDelete = (idx) => {
    const toRemove = files[idx];
    if (isFunction(onFileDelete)) {
      onFileDelete((prev) => (prev || []).filter((f) => f !== toRemove));
    }
  };

  return (
    <Flx wrap sx={sx} gap={0.6}>
      {files?.map((fileObj, idx) => (
        <Button
          onClick={() => handleOnFileDelete(idx)}
          startIcon={
            <AttachFileRounded sx={{ mr: -0.8, fontSize: "14px !important" }} />
          }
          endIcon={
            <CloseRounded
              color="error"
              sx={{ fontSize: "14px !important", ml: -0.1 }}
            />
          }
          variant="outlined"
          key={fileObj.id}
          sx={{ borderRadius: "50px" }}
        >
          {fileObj?.file_display_name}
        </Button>
      ))}
    </Flx>
  );
};

FilesListRenderer.propTypes = {
  files: PropTypes.array,
  onFileDelete: PropTypes.func,
  sx: PropTypes.object,
};

export default FilesListRenderer;
